import * as ApiUtils from 'utils/api-utils';

import type {List, Map, MapOf} from 'immutable';

export const fetchSettings = () => {
    return ApiUtils.callApiMeteorAuthenticated({
        endpoint: '/settings',
        method: 'get',
    });
};

export type UserProfileResponseJS = {
    organizations: List<Map<unknown, unknown>>;
    middleName: string | null;
    passwordValid: boolean;
    lastName: string;
    userId: string;
    active: boolean;
    number: number | null;
    passwordChangeRequired: boolean;
    locked: boolean;
    termsAcceptedTs: string;
    userName: string;
    avatarSignedUrl: string | null;
    firstName: string;
    email: string;
    passwordUpdatedTs: string;
    userGroups: List<
        MapOf<{
            userGroupType: MapOf<{
                ref: string;
            }>;
        }>
    >;
};

export type UserProfileResponse = MapOf<UserProfileResponseJS>;

export const fetchUserProfile = () => {
    return ApiUtils.callApiMeteorAuthenticated<UserProfileResponse>({
        endpoint: '/user/profile',
        method: 'get',
    });
};

export const fetchUserPermissions = () => {
    return ApiUtils.callApiMeteorAuthenticated({
        endpoint: '/users/permissions/global',
        method: 'get',
    });
};

export const fetchUserPreferences = () => {
    return ApiUtils.callApiMeteorAuthenticated({
        endpoint: '/user-preferences',
        method: 'get',
    });
};
